import React, { useState } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import ContextMenu from './HistogramContextMenu';
import { bin, extent } from 'd3-array';

// A function to convert geojson to a format suitable for Nivo
export const convertGeojsonToHistogramData = (geojson, columnKey, minMetricValue, maxMetricValue, numBins = 20) => {
    console.log('here is the input to my function: ', 
        geojson, columnKey, minMetricValue, maxMetricValue
    )
    // Create an array of the values in the geojson data
    const values = geojson.features.map(feature => feature.properties[columnKey]);

    // Use d3's bin function to create an array of bins
    const bins = bin()
        .domain([minMetricValue, maxMetricValue])  // domain is the extent of the data
        .thresholds(numBins)  // number of bins
        (values);

    const totalNumberOfPlants = values.length;

    // Convert the bins to the format expected by Nivo
    const data = bins.map((b, index) => {
        const range = b.length > 0 ? [b[0], b[b.length - 1]] : [0, 0];
        return {
            label: `Bin ${index + 1}`,
            range,  // Add the range of the bin
            [columnKey]: b.length,  // Use the length of the array in each bin as the y value
        };
    });
    console.log('here is the histogram data: ', data)
    return { data, totalNumberOfPlants }
};


export const ContinuousDataHistogram = ({ 
    geojson, 
    columnKey, 
    colorScale, 
    minMetricValue, 
    maxMetricValue, 
    onHistogramFilterPlantPoints }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [clickedData, setClickedData] = useState(null);
    const [isFiltered, setIsFiltered] = useState(false);

    const { data = [], totalNumberOfPlants = 0 } = geojson ? convertGeojsonToHistogramData(geojson, columnKey, minMetricValue, maxMetricValue) : {};
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRightClick = (event) => {
        event.preventDefault(); // prevent the browser's context menu from appearing
        setAnchorEl(event.currentTarget);
    };

    const menuOptions = [

        {
            label: isFiltered ? `Unfilter plant points` : `Filter plant points`,  // Change this line
            action: () => {
              if (isFiltered) {
                // If the histogram is currently filtered, reset the filter
                onHistogramFilterPlantPoints([minMetricValue, maxMetricValue]);
              } else {
                // If the histogram is not currently filtered, apply the filter
                onHistogramFilterPlantPoints(clickedData.data.range.sort((a, b) => a - b));
              }
              setIsFiltered(!isFiltered);  // Toggle the isFiltered state
            },  
        },
    ];

    return (
        <div className="histogram-container" onContextMenu={handleRightClick}>
            <ResponsiveBar
                data={data}
                keys={[columnKey]}
                indexBy={'label'}
                margin={{ top: 10, right: 9, bottom: 10, left: 9 }}
                padding={0.3}
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                axisTop={null}
                axisRight={null}
                axisBottom={null}
                axisLeft={null}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                enableGridY={false}
                enableLabel={false}
                tooltip={({ data }) => 
                    <div style={{ 
                        textAlign: 'center',  
                        backgroundColor: 'rgba(255, 255, 255, 0.8)', 
                        padding: '4px',
                        borderRadius: '4px' }}
                    >
                    {`${data[columnKey]} of ${totalNumberOfPlants} (${((data[columnKey]/totalNumberOfPlants)*100).toFixed(1)}%) plants at ~${((parseFloat(data.range[0]) + parseFloat(data.range[1]))/2).toFixed(1)}`}
                    </div>
                }
                colors={({ data }) => {
                    // Compute the normalized value for the bin
                    const midRange = (data.range[0] + data.range[1]) / 2;
                    const normalizedValue = (midRange - minMetricValue) / (maxMetricValue - minMetricValue);

                    // Use the colorScale function to determine the color
                    return colorScale(normalizedValue).css();
                }}
                onClick={(data, event) => {
                    setClickedData(data);
                    setAnchorEl(event.currentTarget);
                }}
            />
            <ContextMenu anchorEl={anchorEl} handleClose={handleClose} menuOptions={menuOptions} />
        </div>
    )    
};